import actions from "./moduleSettingAction.js";
export default {
  namespaced: true,
  actions: actions,
};
